import { DataTable } from '../../components/admin/data-table';
import { MoonstarList } from '../Moonstar/MoonstarList';

export const NudgeCategoryList = () => (
  <MoonstarList sort={{ field: 'name', order: 'ASC' }}>
    <DataTable rowClick="edit" bulkActionButtons={false}>
      <DataTable.Col source="name" />
    </DataTable>
  </MoonstarList>
);
